import React from "react";
import {
  RadioButton,
  RadioButtonGroup,
  RadioButtonGroupProps
} from "@emisgroup/ui-radio-button";
import { IRadioItem } from "./Types";

interface CustomRadioProps {
  /**
   * Data test id for the current radio button
   */
  dataTestId?: string;
  /**
   * Options
   */
  options: IRadioItem[];
  /**
   * On click event
   */
  onClickEvent: (val: string) => void;
  /**
   * Default value
   */
  defaultValue: string;
  /**
   * Disable fields
   */
  disableFields?: boolean;
}

type RadioProps = RadioButtonGroupProps & CustomRadioProps;


/**
 * Responsible for rendering the radio component
 * @returns radio element
 */
export const UIRadio: React.FC<RadioProps> = (props: RadioProps) => {

  const { options, defaultValue, onClickEvent, dataTestId, disableFields } = props;

  return (
    <RadioButtonGroup
      data-testid="radioGroup"
      defaultValue={defaultValue}
      onChange={(value): void => onClickEvent(value as string)}
      disabled={disableFields}
    >
      {options.map((option: IRadioItem) => (
        <RadioButton
          id={option.id}
          key={option.value}
          value={option.value}
          disabled={option.disabled}
          data-testid={dataTestId}
        >
          {option.text}
        </RadioButton>
      ))}
    </RadioButtonGroup>
  );
};
